import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './LoanHistory.css';
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import ProfileHeader from "../Dashboard/ProfilePage/ProfileHeader";
import { allLeads, getDashboardData } from "../../Utils/api";
import { getStorage, setStorage } from "../../Utils/common";

function LoanHistory() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setStorage("pancard", dashboardData?.Data?.profile_details?.pancard);
        const params1 = {
          pancard: getStorage("pancard")
        };
        allLeads(params1).then((resp) => {
          if (resp?.data?.Status === 1) {
            const LeadData = resp?.data?.Data?.lead_list;
            setLeads(LeadData);
          }
        }).catch(error => {
          console.error("Error fetching leads:", error);
        });
      }
    });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleCardClick = (leadId) => {
    navigate("/my-dashboard/details", { state: { leadId } });
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />
      {/* <div className="loan-history">
        {leads.length > 0 ? (
          leads.map(lead => (
            <div
              key={lead.lead_id}
              className="lead-card"
              onClick={() => handleCardClick(lead.lead_id)}
            >
              <h3>Lead id: {lead.lead_id}</h3>
              <p>Loan Amount: {lead.loan_amount}</p>
              <p>Status: {lead.status}</p>
              <p>Applied Date: {formatDate(lead.lead_entry_date)}</p>
            </div>
          ))
        ) : (
          <p style={{ color: "#1D3557" }}>No loan history found.</p>
        )}
      </div> */}

      <div className="mt-8">
        {leads.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {leads.map((lead) => (
              <div
                key={lead.lead_id}
                onClick={() => handleCardClick(lead.lead_id)}
                className="bg-white rounded-3xl border border-gray-100 shadow-[0_8px_20px_rgba(255,140,80,0.15)] p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(255,140,80,0.25)]"
              >
                {/* Header */}
                <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-4">
                  <h3 className="text-lg font-bold text-[#173A7A]">
                    Lead #{lead.lead_id}
                  </h3>

                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${lead.status?.toLowerCase() === "approved"
                      ? "bg-green-100 text-green-700"
                      : lead.status?.toLowerCase() === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : lead.status?.toLowerCase() === "rejected"
                          ? "bg-red-100 text-red-700"
                          : "bg-blue-100 text-[#173A7A]"
                      }`}
                  >
                    {lead.status || "NA"}
                  </span>
                </div>

                {/* Loan Amount */}
                <div className="flex justify-between items-center border-b border-gray-100 py-3">
                  <span className="text-sm text-gray-500">
                    Loan Amount
                  </span>

                  <span className="font-semibold text-[#173A7A]">
                    ₹{lead.loan_amount || "0"}
                  </span>
                </div>

                {/* Applied Date */}
                <div className="flex justify-between items-center pt-3">
                  <span className="text-sm text-gray-500">
                    Applied Date
                  </span>

                  <span className="font-semibold text-[#173A7A]">
                    {formatDate(lead.lead_entry_date)}
                  </span>
                </div>

                {/* Button */}
                <button className="w-full mt-6 bg-[#173A7A] text-white rounded-xl py-2.5 font-medium hover:bg-blue-900 transition">
                  View Details
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center shadow-sm">
            <p className="text-[#173A7A] text-lg font-medium">
              No loan history found.
            </p>
          </div>
        )}
      </div>
    </ProfilePreviewWrapper>
  );
}

export default LoanHistory;